function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M111.541 94.6659C132.519 97.2612 148.524 104.398 159.554 116.077C170.584 127.756 176.099 142.355 176.099 159.873C176.099 173.066 172.747 185.069 166.042 195.883C159.338 206.697 149.173 215.348 135.547 221.836C122.138 228.108 105.701 231.244 86.2362 231.244C70.0156 231.244 54.3356 228.973 39.1962 224.431C24.2732 219.673 11.5129 213.185 0.91541 204.967L19.0826 172.201C27.3011 179.122 37.2498 184.637 48.9287 188.746C60.8238 192.639 73.0434 194.585 85.5874 194.585C100.51 194.585 112.189 191.558 120.624 185.502C129.275 179.23 133.601 170.795 133.601 160.198C133.601 149.6 129.491 141.382 121.273 135.542C113.271 129.486 100.943 126.458 84.2898 126.458H63.5273V97.5856L115.109 36.2714H11.9455V0.910312H166.691V29.1343L111.541 94.6659Z"
});

function SvgMenuNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 232,
    viewBox: "0 0 177 232",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNumber);
export default __webpack_public_path__ + "static/media/menu-number.b93ed8f2.svg";
export { ForwardRef as ReactComponent };